// Libs
import classNames from 'classnames/bind';
import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
// Components, Layouts, Pages
// Others
import { TIME_OUT_SHOW_COMPLETE } from '~/utils/constants/common';
// Styles, images, icons
import styles from './ReviewComplete.module.scss';
import { icons } from '~/assets';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const cx = classNames.bind(styles);

const ReviewComplete = (props: Props) => {
  //#region Destructuring Props
  const { isOpen, onClose } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/review']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, TIME_OUT_SHOW_COMPLETE);

      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Dialog id='formSchedulePage' open={isOpen} maxWidth={'xs'} fullWidth onClose={onClose}>
      <DialogContent dividers={true}>
        <Box component={'div'} className={cx('bodyWrap')}>
          <Box component={'div'} className={cx('body')}>
            <img
              src={icons.commonIconLogo}
              alt={t('common_alt_img', { ns: 'common/base' })}
              className={cx('logo')}
            />

            <Typography component={'p'} className={cx('title')}>
              {t('review_complete_title')}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ReviewComplete;
